import {ProtocolEnum} from '../../../../../../../../service/company-v2/company-const';

export function getProtocolOptions(
    httpsOnly: boolean,
    showMessengerOptions: boolean
): Array<{value: ProtocolEnum; label: string}> {
    const options: Array<{value: ProtocolEnum; label: string}> = [
        ...(httpsOnly ? [] : [{value: ProtocolEnum.HTTP, label: ProtocolEnum.HTTP}]),
        {value: ProtocolEnum.HTTPS, label: ProtocolEnum.HTTPS},
    ];

    if (showMessengerOptions) {
        options.push({value: ProtocolEnum.WHATSAPP, label: 'WhatsApp'}, {value: ProtocolEnum.VIBER, label: 'Viber'});
    }

    return options;
}
